





















































import { defineComponent, computed, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import percentFasterThanXDays from '@/gql/managementReport/04-DeliveryTime/percentFasterThanXDays.gql';

import {
  NOW,
  NOW_START_YEAR,
  NOW_START_MONTH,
  NOW_END_MONTH,
  toCommaFormat,
} from '@/utils';

import CommonIconTop from '@/components/CommonIconTop.vue';
import analyticRouter from '@/views/Report/Analytic/analytic-router';

const DeliveryTimeStats = defineComponent({
  components: {
    CommonIconTop,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    isYTD: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const filter = reactive({
      yearRange: {
        from: NOW_START_YEAR,
        to: NOW,
      },
      monthRange: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
    });
    const { result, loading } = useQuery(
      percentFasterThanXDays,
      computed(() => ({
        timeframeYTD: filter.yearRange,
        timeframeMTD: filter.monthRange,
      })),
      () => ({
        fetchPolicy: 'network-only',
      }),
    );

    const dataYtd = computed(() => result.value?.percentFasterThanXDays || {});
    const totalYtd = computed(() => Object.values(dataYtd.value).filter((item: any) => item >= 0).reduce((item, acc) => item + acc, 0));
    const dataMtd = computed(() => result.value?.percentMtd || {});
    const totalMtd = computed(() => Object.values(dataMtd.value).filter((item: any) => item >= 0).reduce((item, acc) => item + acc, 0));

    return {
      toCommaFormat,
      percentFasterThanXDays,
      result,
      dataYtd,
      dataMtd,
      totalYtd,
      totalMtd,
    };
  },
});

export default DeliveryTimeStats;
